/**
 * A session cookie's value, when it is a token: never empty, and never `false`, which legacy app-ui's
 * nuxt-auth writes into the session's cookies on the parent domain to sign the browser out when its
 * refresh fails. The one rule for it, in the browser (stores/auth.ts) and at the edge
 * (server/middleware/edge-auth-redirect.ts) alike. useCookie reads a value that parses as JSON as JSON,
 * so a ref holds that sign-out as the boolean, and a read of the jar or of a request's cookies as the
 * string.
 */
export function tokenIn(value: unknown): string | null {
    return typeof value === 'string' && value !== '' && value !== 'false' ? value : null;
}
